import React from "react";
import "./index.css";
import { BiMoon, BiSun } from "react-icons/bi";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootStore } from "../../Store";
import { changeTheme } from "../layout/actions/ThemeActions";
import { FiExternalLink } from "react-icons/fi";

const Header: React.FC<any> = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const themeMode = useSelector((state: RootStore) => state.Theme);

  const toggleTheme = () => {
    dispatch(changeTheme());
  };

  return (
    <div className="header">
      <div className="theme_mode" onClick={toggleTheme}>
        {themeMode.theme === "light" ? (
          <BiMoon size={18} />
        ) : (
          <BiSun size={18} />
        )}
      </div>
      <ul>
        <li>
          <NavLink to="/" exact activeClassName="selected">
            Home {pathname === "/" && <FiExternalLink />}
          </NavLink>
        </li>
        <li>
          <NavLink to="/works" exact activeClassName="selected">
            Works {pathname === "/works" && <FiExternalLink />}
          </NavLink>
        </li>
        <li>
          <NavLink to="/contact" exact activeClassName="selected">
            Contact {pathname === "/contact" && <FiExternalLink />}
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Header;
